<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
	<section class="content-wrapper">
    <h2>{{ companyInfo.company_name}}</h2>
    <div style="width:100%">
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p > 
          <img :src="companyInfo.company_logo" style="width:200px;" >
        </p>
        <p style="font-size: 100%;"><a :href="companyInfo.company_url" target="_blank">{{ companyInfo.company_url | urlencode }}</a></p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 100%;" v-html="companyInfo.company_introduction"></p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 100%;text-align:left;">企業タイプ</p>
        <p style="font-size: 100%;">{{ companyInfo.company_size}}</p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 100%;text-align:left;">勤務環境</p>
        <p v-for="(item, index) in companyInfo.work_environment" :key="index" style="font-size: 100%;">{{ item.value }}</p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 100%;text-align:left;">予定勤務地</p>
        <p v-for="(item, index) in companyInfo.work_place" :key="index" style="font-size: 100%;">{{ item.value }}</p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 100%;text-align:left;">業種</p>
        <p v-for="(item, index) in companyInfo.industry" :key="index" style="font-size: 100%;">{{ item.smallCategory }} {{ item.middleCategory }} {{ item.value }}</p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 100%;text-align:left;">職種</p>
        <p v-for="(item, index) in companyInfo.occupation" :key="index" style="font-size: 100%;">{{ item.smallCategory }} {{ item.middleCategory }} {{ item.value }}</p>
      </div>
    </div>
    <div class="text-center"  >
      <el-button id="resend_secure" type="success" style="background-color:#e3165c;border-color:#e3165c;color:#FFF"
      @click="submitYagioffer()"
        >まずは話を聞いてみる</el-button>
    </div>
    <div class="text-center" v-if="!$firebase.isAuthenticated">
      <login-forms />
    </div>
	</section>

</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>

<script>

// import LoginForms from '@/components/RenewLoginForms'
import LoginForms from '@/components/LoginSpecialForms'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  props: {
    offerUid: {
      type: String
    },
    uid: {
      type: String
    }
  },
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: false,
      token: null,
      companyInfo:null
    }
  },
  computed: {
  },
  methods: {
    submitYagioffer: function() {

      const formData = new FormData()
      formData.append('uuid', this.uid)
      formData.append('offer_uid', this.offerUid)
      const app = this
      app.$axios.get(this.$varuna.endPoints.submitYagioffer, {
        params: {
          uuid: app.uid,
          offer_uid: app.offerUid
        }
      })
    }
    
  },
  created: function () {
  },
  beforeMount: function () {
    const app = this
    app.fullscreenLoading = true
    const formData = new FormData()
    formData.append('uuid', '-')
    formData.append('offer_uid', app.offerUid)

    this.$axios
      .post(this.$varuna.endPoints.getCompanyDetailInfo, formData, {timeout: 60000})
      .then(function (response) {
        app.companyInfo = response.data.company_info.data

      })
      .catch(function (error) {
      }).finally(function () {
        app.fullscreenLoading = false
      })
  },
  destroyed: function () {
  }
}
</script>
